import React, { useEffect } from "react";
import { makeStyles, styled, TableCell, TableRow } from "@material-ui/core";
import { columns } from "./../thead";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import Modalsymbol from './../modalsymbol';
import { handleNumber } from "../../../../../../method/displayData";

let useStyles = makeStyles((theme) => ({
    root: {
        width: "35%",
        minWidth: "33%",
        minHeight: "25vh",
        overflow: "auto",
        backgroundColor: "white",
        padding: 15,
        borderRadius: 5,
        border: "none",
        [theme.breakpoints.down("sm")]: {
            width: "90%",
            maxHeight: "80vh",
        },
    },
    modal: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        overflow: "auto",
    },
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
        backgroundColor: "#F2F4F6",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));


export default function Index({ info, index, handleLink, stock, setStock }) {

    let classes = useStyles();
    const [open, setOpen] = React.useState(false);

    return (
        <>
            <StyledTableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={index}
                style={{ height: 60 }}
                onClick={() => {
                    setOpen(true);
                }}

            >
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {handleLink(info?.body['Attachment'])}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {
                        info?.body?.trade_date
                    }
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.commodity_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.offer_symbol}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.manufacturer_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.final_weighted_average_price}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.offer_volume}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.contract_type_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.offer_base_price}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {handleNumber(info?.body?.maximum_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {handleNumber(info?.body?.minimum_price)}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.supplier_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.currency_detail?.persianName}
                </TableCell>
                <TableCell
                    align="center"
                    dir={"rtl"}
                >
                    {info?.body?.measurement_unit_detail?.persianName}
                </TableCell>

            </StyledTableRow>
            {
                open && (
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        className={classes.modal}
                        open={open}
                        onClose={() => setOpen(false)}
                        closeAfterTransition
                        BackdropComponent={Backdrop}
                        BackdropProps={{
                            timeout: 500,
                        }}
                    >
                        <Fade in={open}>
                            <div className={classes["root"]}>
                                {
                                    open && (
                                        <Modalsymbol
                                            open={open}
                                            data={info}
                                            setOpen={setOpen}
                                            stock={stock}
                                            setStock={setStock}
                                        />
                                    )
                                }
                            </div>
                        </Fade>
                    </Modal>

                )
            }

        </>
    )
}


let test =
{
    'buy_method': 'عادی', 
    'commodity_id': 15286,
     'commodity_detail': {'symbol': 'CEMENT5-50L', 'parentId': 170, 'description': 'سیمان تیپ 5/کیسه50', 'persianName': 'سیمان تیپ 5/کیسه50', 'id': 15286},
     'contract_type_id': 7,
     'contract_type_detail': {'description': 'نقدی (مچینگ)', 'persianName': 'نقدی (مچینگ)', 'id': 7},
     'currency_id': 1,
     'currency_detail': {'description': 'ریال', 'persianName': 'ریال', 'id': 1}, 
    'demand_volume': 100,
     'due_date': '',
     'final_weighted_average_price': 9653,
     'manufacturer_id': 5217, 
    'manufacturer_detail': {'symbol': 'TCC', 'description': 'سیمان تهران', 'persianName': 'سیمان تهران', 'id': 5217}, 
    'maximum_price': 9653,
     'measurement_unit_id': 1, 
    'measurement_unit_detail': {'description': 'کیلوگرم', 'persianName': 'کیلوگرم', 'id': 1},
     'minimum_price': 9653,
     'offer_base_price': 9653,
     'offer_id': 724888,
     'offer_mode': 'عمده', 
    'offer_symbol': 'TCC-CEMENT5-50L-00',
     'offer_type': 'عرضه داخلی', 
    'offer_volume': 0, 
    'seller_broker_id': 45,
     'seller_broker_detail': {'nationalId': '10860222183', 'spotId': 45, 'derivativesId': 305, 'description': 'مبین سرمایه', 'persianName': 'مبین سرمایه', 'id': 45},
     'supplier_id': 3364,
     'supplier_detail': {'customerId': 15124, 'nationalCode': '10861081241', 'description': 'سیمان تهران', 'persianName': 'سیمان تهران', 'id': 3364}, 
    'trade_date': '1402/10/02', 
    'trade_value': 965300, 
    'trade_volume': 100,
     'id_trade': 724888
    }